import type { EntityField } from '../components/CsvImportDialog';


// Demand entity field definitions
// "materialLookup" is a virtual field: config has one row "Material-Lookup"; at runtime it fills materialId + materialName from lookup.
export const demandEntityFields: EntityField[] = [
  {
    field: 'materialLookup',
    label: 'Material-Lookup',
    type: 'text',
    required: true
  },
  {
    field: 'demandDate',
    label: 'Demand Date',
    type: 'date',
    required: true
  },
  {
    field: 'dueTime',
    label: 'Due Time',
    type: 'text',
    required: true  // mandatory in the business sense; when the value is missing, the backend/import sets the default delivery time
  },
  {
    field: 'quantity',
    label: 'Quantity',
    type: 'number',
    required: true
  },
  // demandId is computed by backend from composite key config; not mappable in CSV
  // status, source, priority and notes: internal only, not in CRUD/CSV
  {
    field: 'customerOrderNumber',
    label: 'Customer Order Number',
    type: 'text',
    required: false
  }
];

// Export all entity field configurations
export const entityFieldsConfig = {
  demand: demandEntityFields
};

export type EntityType = keyof typeof entityFieldsConfig;

